import { Grid, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { C_OUTLINE_VARIANT } from "~/common/components/icon/Colors";

export function MMDFilterSkeleton() {
  const renderTextFieldSkeleton = () => (
    <Grid size={4}>
      <FilterSkeletonBox>
        <Skeleton width="auto" height={40} />
      </FilterSkeletonBox>
    </Grid>
  );
  const filterRowSkeleton = () => (
    <FilterRow container size={12}>
      <Skeleton width={216} height={24} />
      <Grid container size={12} spacing={2}>
        {renderTextFieldSkeleton()}
        {renderTextFieldSkeleton()}
        {renderTextFieldSkeleton()}
      </Grid>
    </FilterRow>
  );

  return (
    <FilterContainer container size={12}>
      {filterRowSkeleton()}
      {filterRowSkeleton()}
    </FilterContainer>
  );
}

export function MMDTableSkeleton() {
  const singleCellSkeleton = (key: number) => (
    <TableCell key={key}>
      <Skeleton width={100} height={20} />
    </TableCell>
  );

  const tableWithFilledCell = (key?: number) => (
    <TableRow key={key}>{[...Array(8)].map((e, i) => singleCellSkeleton(i))}</TableRow>
  );
  return (
    <Table>
      <TableHead>{tableWithFilledCell()}</TableHead>
      <TableBody>
        {[...Array(4)].map((e, i) => tableWithFilledCell(i))}
        <TableRowWithBorderTop>
          <TableCell />
          <TableCell colSpan={2}>
            <Skeleton width={120} height={20} />
          </TableCell>
          <TableCell colSpan={2} />
          <TableCell>
            <Skeleton width={72} height={20} />
          </TableCell>
          <TableCell />
          <TableCell>
            <Skeleton width={116} height={20} />
          </TableCell>
        </TableRowWithBorderTop>
      </TableBody>
    </Table>
  );
}

const FilterContainer = styled(Grid)(({ theme }) => ({
  padding: "16px",
  gap: "24px",
}));

const FilterRow = styled(Grid)(({ theme }) => ({
  gap: "8px",
}));

const FilterSkeletonBox = styled(Grid)({
  width: "auto",
  height: "40px",
});

const TableRowWithBorderTop = styled(TableRow)({
  borderTop: `3px solid ${C_OUTLINE_VARIANT}`,
});
